"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cryptoService = void 0;
var _x = _interopRequireDefault(require("node-forge/lib/x509"));
var _util = _interopRequireDefault(require("node-forge/lib/util"));
var _core = _interopRequireDefault(require("crypto-js/core"));
var _libTypedarrays = _interopRequireDefault(require("crypto-js/lib-typedarrays"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var _encHex = _interopRequireDefault(require("crypto-js/enc-hex"));
var _encUtf = _interopRequireDefault(require("crypto-js/enc-utf8"));
var _aes = _interopRequireDefault(require("crypto-js/aes"));
var _pbkdf = _interopRequireDefault(require("crypto-js/pbkdf2"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var wordArrayToByteArray = function wordArrayToByteArray(wordArray) {
  var length = 0;
  var words = [];
  if (wordArray.sigBytes && wordArray.words) {
    length = wordArray.sigBytes;
    words = wordArray.words;
  }
  var result = [];
  var bytes;
  var i = 0;
  while (length > 0) {
    bytes = wordToByteArray(words[i], Math.min(4, length));
    length -= bytes.length;
    result.push(bytes);
    i += 1;
  }
  return result;
};
var byteArrayToWordArray = function byteArrayToWordArray(ba) {
  var wa = [];
  var i;
  for (i = 0; i < ba.length; i += 1) {
    /* eslint-disable-next-line no-bitwise  */
    wa[i / 4 | 0] |= ba[i] << 24 - 8 * i;
  }
  return _libTypedarrays["default"].create(wa);
};
var wordToByteArray = function wordToByteArray(word, length) {
  var ba = [];
  var xFF = 0xff;
  /* eslint-disable no-bitwise  */
  if (length > 0) {
    ba.push(word >>> 24);
  }
  if (length > 1) {
    ba.push(word >>> 16 & xFF);
  }
  if (length > 2) {
    ba.push(word >>> 8 & xFF);
  }
  if (length > 3) {
    ba.push(word & xFF);
  }
  /* eslint-enable no-bitwise  */

  return ba;
};
var rsaEncrypt = function rsaEncrypt(key) {
  var rsa = _x["default"].publicKeyFromPem(process.env.API_PUBLIC_KEY);
  var en = rsa.encrypt(_util["default"].encodeUtf8(key));
  var en64 = _util["default"].encode64(en);
  return en64;
};
var encrypt = function encrypt(input) {
  var salt = _libTypedarrays["default"].random(16);
  var keySize = 256;
  var pass = process.env.API_PRIVATE_KEY;
  var key = (0, _pbkdf["default"])(pass, salt, {
    keySize: keySize / 32,
    iterations: 1000
  });
  var iv = _libTypedarrays["default"].random(128 / 8);
  var body = _aes["default"].encrypt(input, key, {
    iv: iv,
    mode: _core["default"].mode.CBC,
    padding: _core["default"].pad.Pkcs7
  });
  // Convert Lib.WordArray to ByteArray so we can combine them like Concat
  var saltwords = wordArrayToByteArray(salt);
  var ivwords = wordArrayToByteArray(iv);
  var cryptedText = wordArrayToByteArray(body.ciphertext);
  // combine everything together in ByteArray.
  var header = saltwords.concat(ivwords).concat(cryptedText);
  // Now convert to WordArray.
  var headerWords = byteArrayToWordArray(header);
  // const innerEn = salt.concat(iv).concat(body.ciphertext);
  // Encode this to sent to server
  var ext = _encBase["default"].stringify(headerWords);
  var inner = salt.toString() + iv.toString() + body.toString();
  return {
    ext: ext,
    "int": inner
  };
};
var decrypt = function decrypt(input) {
  var salt = _encHex["default"].parse(input.substr(0, 32));
  var iv = _encHex["default"].parse(input.substr(32, 32));
  var ciphertext = input.substring(64);
  var keySize = 256;
  var pass = process.env.API_PRIVATE_KEY;
  var key = (0, _pbkdf["default"])(pass, salt, {
    keySize: keySize / 32,
    iterations: 1000
  });
  var decryted = _aes["default"].decrypt(ciphertext, key, {
    iv: iv,
    mode: _core["default"].mode.CBC,
    padding: _core["default"].pad.Pkcs7
  });
  return _encUtf["default"].stringify(decryted);
};
var crypto = exports.cryptoService = {
  rsaEncrypt: rsaEncrypt,
  encrypt: encrypt,
  decrypt: decrypt
};